// extracted by mini-css-extract-plugin
export default {"container":"sD-z","dimension":"tD-z","dimensionLabels":"uD-z"};